module.exports = __webpack_public_path__ + "img/uberall-logo.97c907f7.jpg";